import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from 'src/app/guards/auth.guard';
import { Role } from 'src/app/models/shared/role';
import { LoginComponent } from 'src/app/modules/login/login.component';
import { ListHistoryComponent } from "src/app/modules/history/list-history.component";
import { ListDocumentsComponent } from 'src/app/modules/management/document/list-documents.component';
import { ListCompanyComponent } from './modules/management/company/list-company.component';
import { HomeComponent } from './modules/home/components/home.component';
import { RollCallComponent } from './modules/roll-call/roll-call.component';
import { ListCaeUserComponent } from './modules/management/cae-user/list-cae-user.component'; 
import { ListRecordCaeUserComponent } from './modules/management/cae-user/list-record-cae-user.component';

const routes: Routes = [
  { path: 'home', component: HomeComponent },
  {
    path: 'list-documents',
    canActivate: [AuthGuard],
    component: ListDocumentsComponent,
    data: { roles: [Role.Admin, Role.Gestor, Role.SuperAdmin, Role.RRHH, Role.EXECUTIVE] }
  },
  {
    path: 'management',
    loadChildren: () => import('./modules/management/management.module').then(m => m.ManagementModule),
    canActivate: [AuthGuard],
    data: { roles: [Role.Admin, Role.Gestor, Role.SuperAdmin, Role.RRHH, Role.EXECUTIVE] }
  },
  {
    path: 'list-history',
    component: ListHistoryComponent,
    canActivate: [AuthGuard],
    data: { roles: [Role.SuperAdmin, Role.Admin, Role.Gestor] }
  },
  {
    path: 'list-company',
    component: ListCompanyComponent,
    canActivate: [AuthGuard],
    data: { roles: [Role.SuperAdmin] },
  },
  {
    path: 'list-roll-call',
    component: RollCallComponent,
    canActivate: [AuthGuard],
    data: { roles: [Role.Admin, Role.RRHH, Role.EXECUTIVE] },
  },
  {
    path: 'schedule',
    loadChildren: () => import('./modules/management/schedule/schedule.module').then(m => m.ScheduleModule),
    canActivate: [AuthGuard],
    data: { roles: [Role.Admin, Role.RRHH, Role.EXECUTIVE] }
  },
  {
    path: 'cae-user-list',
    component: ListCaeUserComponent,
    canActivate: [AuthGuard],
    data: { roles: [Role.Admin, Role.RRHH, Role.EXECUTIVE] }
  },
  {
    path: 'record-caeuser-list',
    component: ListRecordCaeUserComponent,
    canActivate: [AuthGuard],
    data: { roles: [Role.Admin, Role.EXECUTIVE] }
  },
  { path: '**', component: LoginComponent },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
